// 2D Reconstruction Thumbnails
import youngMaleThumb from './../Images/Reconstructions/2D/young-male-thumb.jpg'
import youngMaleImage from './../Images/Reconstructions/2D/young-male-main.jpg'
import bentNoseThumb from './../Images/Reconstructions/2D/bent-nose-thumb.jpg'
import bentNoseImage from './../Images/Reconstructions/2D/bent-nose-main.jpg'
import youngFemaleThumb from './../Images/Reconstructions/2D/young-female-thumb.jpg'
import youngFemaleImage from './../Images/Reconstructions/2D/young-female-main.jpg'
import aragornImage from './../Images/Reconstructions/2D/aragorn-main.jpg'
import aragornThumb from './../Images/Reconstructions/2D/aragorn-thumb.jpg'

// 3D Reconstruction Thumbnails
import koreanFemaleImage from './../Images/Reconstructions/3D/korean-female-main.jpg'
import koreanFemaleThumb from './../Images/Reconstructions/3D/korean-female-thumb.jpg'
import robertoMaleImage from './../Images/Reconstructions/3D/roberto-male-main.jpg'
import robertoMaleThumb from './../Images/Reconstructions/3D/roberto-male-thumb.jpg'
import winstonMaleImage from './../Images/Reconstructions/3D/winston-male-main.jpg'
import winstonMaleThumb from './../Images/Reconstructions/3D/winston-male-thumb.jpg'
import tysonMaleImage from './../Images/Reconstructions/3D/tyson-male-main.jpg'
import tysonMaleThumb from './../Images/Reconstructions/3D/tyson-male-thumb.jpg'

class Data {
  static getReconstructions() {
    return [
      {
        id: '3d',
        title: '3D Reconstructions',
        summary: 'These 3D reconstructions were created in clay using the Manchester method, this method requires the application of tissue depth pegs, facial muscles and lastly the skin layer. These reconstructions were built up from casts of real skulls this results in a very accurate facial reconstruction.',
        items: [
          {
            id: 1,
            title: "Young/Middle Aged Female",
            description: "This individual was a young to middle aged female of Asian ancestry. The skull cast was acquired from a cone beam CT scan, as a result the skull and reconstruction were missing the superior and posterior regions. The facial reconstruction was created in clay using a muscle and tissue depth peg technique.",
            image: koreanFemaleImage,
            thumbnail: koreanFemaleThumb,
            imageAlt: "Young/Middle Aged Asian Female Reconstruction Thumbnail"
          },
          {
            id: 2,
            title: "Young Male",
            description: "This individual was a young caucasian male. The facial reconstruction was done in clay using a muscle and tissue depth peg technique.",
            image: robertoMaleImage,
            thumbnail: robertoMaleThumb,
            imageAlt: "Young Male Reconstruction Thumbnail"
          },
          {
            id: 3,
            title: "Middle Aged/Older Male",
            description: "This individual was a middle aged to older caucasian male. The facial reconstructionw as done in clay using a muscle and tissue depth peg technique.",
            image: winstonMaleImage,
            thumbnail: winstonMaleThumb,
            imageAlt: "Middle Aged/Older Male Reconstruction Thumbnail"
          },
          {
            id: 4,
            title: "Robust Middle Aged Male",
            description: "This individual was a middle aged caucasian male with large muscle attachments and a diastema between his two front teeth. The facial reconstruction was done in clay using a muscle and tissue depth peg technique. The lips were left open so the diastema remained visible.",
            image: tysonMaleImage,
            thumbnail: tysonMaleThumb,
            imageAlt: "Robust Middle Aged Male Reconstruction Thumbnail"
          }
        ]
      },
      {
        id: '2d',
        title: '2D Reconstructions',
        summary: 'These reconstructions are 2D and were formed entirely in Adobe Photoshop to create a close to photographic image. They were created using the Manchester method, this method requires the application of tissue depth pegs, facial muscles and lastly the skin layer. Unfortunately these have lower levels of accuracy due to being entirely 2D and based upon photographs rather than the skull itself.',
        items: [
          {
            id: 1,
            title: "Young Male",
            description: "This reconstruction is from an archaeological skull held at the Museum of Edinburgh. The individual was a young caucasian male and the 2D facial reconstruction was constructed in Adobe Photoshop using a muscle and tissue depth peg technique. This individual had a particularly feminine looking skull, a gracile bone structure and large orbits leading to a large and open eye shape.",
            image: youngMaleImage,
            thumbnail: youngMaleThumb,
            imageAlt: "Young Male Reconstruction Thumbnail"
          },
          {
            id: 2,
            title: "Middle Aged/Older Male",
            description: "This reconstruction is from an archaeological skull held at the Museum of Edinburgh. The individual was a caucasian middle aged to older male and the 2D facial reconstruction was constructed in Adobe Photoshop using a muscle and tissue depth peg technique. When assessing the skull prior to reconstruction it was noted that the nasal bones had a healed break, this meant the nose would have been bent towards the left side of the face.",
            image: bentNoseImage,
            thumbnail: bentNoseThumb,
            imageAlt: "Middle Aged/Older Male Reconstruction Thumbnail"
          },
          {
            id: 3,
            title: "Young Female",
            description: "This reconstruction is from an archaeological skull held at the Museum of Edinburgh. The individual was a young caucasian female and the 2D facial reconstruction was constructed in Adobe Photoshop using a muscle and tissue depth peg technique.",
            image: youngFemaleImage,
            thumbnail: youngFemaleThumb,
            imageAlt: "Young Female Reconstruction Thumbnail"
          },
          {
            id: 4,
            title: "Middle Aged/Older Male",
            description: "This reconstruction is from an archaeological skull held at the Museum of Edinburgh. The individual was a middle aged to older caucasian male and the 2D facial reconstruction was constructed in Adobe Photoshop using a muscle and tissue depth peg technique.",
            image: aragornImage,
            thumbnail: aragornThumb,
            imageAlt: "Middle Aged/Older Male Reconstruction Thumbnail"
          }
        ]
      }
    ]
  }
}

export default Data



// WEBPACK FOOTER //
// ./src/Data/index.js